const header = document.querySelector('#header');

const hideHeader = () => {
  header.classList.add('header--hide');
};

const showHeader = () => {
  header.classList.remove('header--hide');
};

let lastScrollTop = 0;
window.addEventListener('scroll', () => {
  const st = window.pageYOffset;
  st >= 400
    ? (hideHeader(),
      st < lastScrollTop && header.classList.remove('header--hide'),
      (lastScrollTop = st <= 0 ? 0 : st))
    : showHeader();
});
